module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1020-85c53ee6a41d45e7890f10f3803e802f.png";